import React, { useState } from "react";

import { Grid, Container, Typography } from "@material-ui/core";

import InvestSummery from "./InvestSummery";
import InvestCard from "./InvestCard";
import InvestHistory from "./InvestHistory";
import InvestCommissionBox from "./InvestCommissionBox";

function Invest({ network }) {
  const [selectedContract, setSelectedContract] = useState({});
  const [historyKey, setHistoryKey] = useState(0);

  const changeHistoryKey = () => {
    setHistoryKey(historyKey + 1);
  };

  return (
    <div id="invest">
      <Container maxWidth="xl">
        <Typography variant="h6" className="mb-4">
          Invest
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <InvestSummery
              key={selectedContract.contractAddress}
              network={network}
              selectedContract={selectedContract}
            />
          </Grid>

          <Grid item xs={12} md={6}>
            <Grid container spacing={2}>
              {selectedContract.contractAddress && (
                <Grid item xs={12}>
                  <InvestCommissionBox
                    key={selectedContract.contractAddress}
                    network={network}
                    selectedContract={selectedContract}
                  />
                </Grid>
              )}
              <Grid item xs={12}>
                <InvestCard
                  network={network}
                  set_contractInfo={(info) => setSelectedContract(info)}
                  changeHistoryKey={changeHistoryKey}
                />
              </Grid>
            </Grid>
          </Grid>

          <Grid item xs={12}>
            <InvestHistory
              key={historyKey}
              network={network}
              selectedContract={selectedContract}
            />
          </Grid>
        </Grid>
      </Container>
    </div>
  );
}

export default Invest;
